import { brandName, contactEmail, navLinks, categories } from "@/mocks/guaContent";

export default function Footer() {
  return (
    <footer className="relative bg-accent-50 border-t border-accent-200">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-white text-lg">
                <i className="ri-newspaper-fill"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">{brandName}</span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              把今天的瓜都给你攒齐。每日更新、定期推送，做干净可信又好看的泛娱乐资讯瓜报。
            </p>
            <a
              href={`mailto:${contactEmail}`}
              className="mt-4 inline-flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 transition"
            >
              <i className="ri-mail-line"></i> {contactEmail}
            </a>
          </div>

          <nav aria-label="订阅栏目">
            <h4 className="text-sm font-bold text-foreground-900">订阅栏目</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.slice(0, 5).map((c) => (
                <li key={c.name}>
                  <a href="#plans" className="text-sm text-foreground-600 hover:text-primary-600 transition">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="站点导航">
            <h4 className="text-sm font-bold text-foreground-900">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-sm text-foreground-600 hover:text-primary-600 transition">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">订阅服务</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li>瓜田日报 · 工作日每日一更</li>
              <li>瓜田周报 · 每周六精选复盘</li>
              <li>电子报刊 · 深度长文与解读</li>
            </ul>
            <a
              href="#plans"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-900 text-white text-sm font-semibold px-5 py-2.5 hover:bg-foreground-950 transition"
            >
              立即订阅 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-accent-200 pt-6 text-xs text-foreground-500">
          <p>© {new Date().getFullYear()} {brandName} · 内容仅供信息聚合与娱乐参考，事件详情请以官方信源为准。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-mail-send-line"></i> 随时退订，绝不打扰
          </p>
        </div>
      </div>
    </footer>
  );
}